import UserFavoritesListValueObject from './UserFavoritesListValueObject.js'

export default class UserValueObjectsFactory {
  static userFavoritesListValueObject = ({ads, contracts, totalAds, totalContracts}) =>
    new UserFavoritesListValueObject({ads, contracts, totalAds, totalContracts})
}
